import { Home, Search, User } from "lucide-react";
import { NavLink } from "react-router-dom";

import "./BottomNav.css";

export const BottomNav = () => {
  return (
    <nav className="bottom-nav">
      <NavLink to="/feed" className="bottom-nav-item">
        <Home size={24} />
        {/* <span>Главная</span> */}
      </NavLink>

      <NavLink to="/search" className="bottom-nav-item">
        <Search size={24} />
        {/* <span>Поиск</span> */}
      </NavLink>

      <NavLink to="/profile" className="bottom-nav-item">
        <User size={24} />
        {/* <span>Профиль</span> */}
      </NavLink>
    </nav>
  );
};
